<h4 class="page-header title-300">Atualize seu cadastro!</h4>


<div class="card card-flex">
  <div class="card-body">

    <div class="row">
        <span class="col-sm-12 texto-h6-padding-bottom">Por gentileza, verifique se <strong class="texto-destaque">todos</strong> os dados abaixo estão corretos.</span>
    </div>

    <dl class="row">
      <dt class="col-sm-2">E-mail Principal:</dt>
      <dd class="col-sm-9">{{ consumidor.emailPrincipal }}&nbsp;     
            <div *ngIf="this.mensagemEmailPrincipal" class="text-danger">
                  {{ this.mensagemEmailPrincipal }}
           </div>
      </dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-2">E-mail Opcional:</dt>
      <dd class="col-sm-9">{{ consumidor.emailOpcional }}&nbsp;&nbsp;   
           <div *ngIf="this.mensagemEmailOpcional" class="text-danger">
                  {{ this.mensagemEmailOpcional }}
           </div>
      </dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-2">Telefone Contato:</dt>
      <dd class="col-sm-9">{{ consumidor.dddTelefone + '' + consumidor.telefone | telefoneMask }}&nbsp; 
            <div *ngIf="this.mensagemTelefonePrincipal" class="text-danger">
                  {{ this.mensagemTelefonePrincipal }}
           </div>
      </dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-2">Telefone Opcional:</dt>
      <dd class="col-sm-9">{{ consumidor.dddCelular + '' + consumidor.celular | telefoneMask }}&nbsp;
           <div *ngIf="this.mensagemTelefoneOpcional" class="text-danger">
                  {{ this.mensagemTelefoneOpcional }}
           </div>
        </dd>
    </dl>

    <div class="row">
        <span class="col-sm-12 texto-h6-padding-top">{{this.msgAviso}}</span>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-6 botao-padding-left">
                <button type="button" class="btn btn-blue margem-a-direita"
                data-toggle="tooltip" data-placement="top" 
                title="Confirmar" 
                [disabled]="!this.contatoValido"
                (click)="confirmarCadastroAtualizado()">Confirmar</button>
                <button type="button" class="btn btn-blue"
                data-toggle="tooltip" data-placement="top" title="Alterar Dados" (click)="onAlterarDadosClick()">Alterar Dados</button>
            </div>
        </div>
    </div>

    <div class="row">
        <span class="col-sm-12 texto-h6-padding-top">Mantenha seu cadastro atualizado, inclusive endereço, pois <strong class="texto-destaque">isso facilita a sua localização em caso de contemplação</strong> nos Sorteios Mensais e Especial.</span>
    </div>

  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-atualizar-cadastro/consumidor-atualizar-cadastro.component.html